import { connect } from 'react-redux';
import VideoOverlay from './VideoOverlay';
import { CLOSE_VIDEO_OVERLAY } from '../../actions/videoOverlay.actions';

const stateToProps = (state) => {
  return { ...state.videoOverlay };
};

const dispatchToProps = (dispatch) => {
  return {
    close: () => dispatch({ type: CLOSE_VIDEO_OVERLAY }),
  };
};

export default connect(stateToProps, dispatchToProps)(VideoOverlay);
